export enum httpHeadersType {
  ONLY_ACCESS_TOKEN,
  ONLY_ACCESSTOKEN,
  ONLY_AUTHORIZATION,
  ALLHEADERS,
}
